import _ from 'lodash';
import { hideModal, setPreventClosing, showModal } from 'models/modals';
import { $modals } from 'models/store-modals';

import { ModalityState } from 'components/Modals/Modality';

import { type RegisteredModals } from 'types/Modals';

export interface ModalInterface {
    isOpened: boolean;
    preventClosing: boolean;
    state: any;
    suppressed: boolean;
    openTimestamp: number;
    shouldMount: boolean;
}

const ModalsService = {
    showModal: (modalName: RegisteredModals, state?: any) => {
        showModal({ modalName, state });
    },
    hideModal,
    toggleModal: (name: RegisteredModals, state?: any) => {
        const isOpened = $modals.map((modals) => modals?.[name]?.isOpened).getState();
        if (isOpened) {
            ModalsService.hideModal(name);
        } else {
            ModalsService.showModal(name, state);
        }
    },
    getModalData: (name: RegisteredModals) => {
        return $modals.map((modals) => modals[name]).getState();
    },
    hideAllModals: () => {
        const modals = _.keys($modals.getState()) as RegisteredModals[];
        modals.forEach((key) => {
            ModalsService.hideModal(key);
        });
    },
    showModality: (title: ModalityState['title'], body: ModalityState['body'], options?: ModalityState['options']) => {
        const modalityState: ModalityState = { title, body, options };
        ModalsService.showModal('MODALITY', modalityState);
    },
    getModalsStack: () => {
        return _($modals.getState())
            .keys()
            .map((key) => ({
                key,
                ..._.pick($modals.map((modals) => modals?.[key as RegisteredModals]).getState(), [
                    'isOpened',
                    'openTimestamp',
                ]),
            }))
            .filter({ isOpened: true })
            .orderBy('openTimestamp', 'desc')
            .map('key')
            .value();
    },
    setPreventClosing: (modalName: RegisteredModals, preventClosing: boolean) => {
        setPreventClosing({ modalName, preventClosing });
    },
    isSuppressed: (name: RegisteredModals) => {
        return ModalsService.getModalsStack()[0] !== name;
    },
};

declare global {
    interface Window {
        modals: typeof ModalsService;
    }
}

window.modals = ModalsService;

export default ModalsService;
